var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC7B7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61BCA4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7FFF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.7238486,28.8509823 C29.3183176,28.2565133 30.3090992,28.2565133 30.9035682,28.8509823 C31.4980371,29.4454512 31.4980371,30.4362328 30.9035682,31.0307018 C29.8467344,32.0875355 29.9788387,33.9369945 31.1677766,35.1259324 L31.1677766,35.1259324 L35.9895804,39.9477362 C36.6501014,40.5422052 37.5087788,40.9385178 38.3014041,40.9385178 C38.8298209,40.9385178 39.5563941,40.8064136 40.1508631,40.2119447 C40.8113841,39.5514236 40.8774362,38.7587983 40.8774362,38.2303814 C40.8774362,37.4377562 40.4811236,36.6451309 39.8866547,36.0506619 L39.8866547,36.0506619 L37.9711436,34.1351508 C37.3766746,33.5406818 37.3766746,32.5499003 37.9711436,31.9554313 C38.5656125,31.3609623 39.5563941,31.3609623 40.1508631,31.9554313 L40.1508631,31.9554313 L42.0663742,33.8709424 C43.2553121,35.0598803 43.9158332,36.5130267 43.9818853,38.0982772 C44.1139895,39.6835278 43.5195205,41.2687784 42.3305826,42.4577163 C41.2737489,43.51455 39.8206026,44.1090189 38.3014041,44.1090189 C36.6501014,44.1090189 34.9987988,43.3824458 33.8098608,42.1935078 L33.8098608,42.1935078 L28.988057,37.3717041 C27.733067,36.116714 27.0725459,34.4654113 27.0725459,32.8801608 C27.0725459,31.3609623 27.6009628,29.9738681 28.7238486,28.8509823 Z M25.6854517,20 C27.3367544,20 28.988057,20.7265732 30.176995,21.9155111 L30.176995,21.9155111 L34.9987988,26.7373149 C36.2537888,27.9923049 36.9143099,29.6436076 36.9143099,31.2288581 C36.9143099,32.7480566 36.385893,34.1351508 35.2630072,35.2580366 C34.6685382,35.8525056 33.6777566,35.8525056 33.0832877,35.2580366 C32.4888187,34.6635677 32.4888187,33.6727861 33.0832877,33.0783171 C34.1401214,32.0214834 34.0080172,30.1720244 32.8190793,28.9830865 L32.8190793,28.9830865 L27.9972754,24.1612827 C27.3367544,23.5007616 26.478077,23.1705011 25.6854517,23.1705011 C25.1570349,23.1705011 24.4304617,23.3026053 23.8359927,23.8970743 C23.1754717,24.5575954 23.1094196,25.3502206 23.1094196,25.8786375 C23.1754717,26.6712628 23.5717843,27.3978359 24.1662533,27.9923049 L24.1662533,27.9923049 L26.1478165,29.9738681 L26.1478165,29.9738681 L26.2458796,30.082727 C26.7324576,30.6835283 26.6373791,31.5940874 26.0157122,32.1535876 C25.4212433,32.7480566 24.4304617,32.7480566 23.8359927,32.1535876 L23.8359927,32.1535876 L22.5810027,30.8325455 L21.9204816,30.1720244 C20.7315437,28.9830865 20.0710227,27.5299402 20.0049705,25.9446896 C19.9389185,24.3594391 20.5333874,22.7741885 21.6562732,21.6513027 C22.7131069,20.594469 24.1662533,20 25.6854517,20 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-25.0%",
    y: "-24.9%",
    width: "150.0%",
    height: "149.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.400416083   0 0 0 0 0.656702899   0 0 0 0 0.588359748  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "APP\\u5C55\\u793A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5206\\u4EAB",
    transform: "translate(-156.000000, -646.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(156.000000, 646.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "url(#linearGradient-1)",
    cx: 32,
    cy: 32,
    r: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-2)",
    xlinkHref: "#path-3"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.9c278a76d42c86ac175ce357ddf62bb5.svg";
export { ForwardRef as ReactComponent };